// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M4jzqRbQKwUFXWqA{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center}.M4jzqRbQKwUFXWqA .IbKOtk8qLcnfREuE{font-size:48px;color:var(--py-red-6)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `M4jzqRbQKwUFXWqA`,
	"icon": `IbKOtk8qLcnfREuE`
};
export default ___CSS_LOADER_EXPORT___;
